import React from "react";
import {observer} from "mobx-react";
import useCurrentSmartview from "../hooks/use-current-smartview";

function RenderCurrentSmartview(props) {

    const [smartview] = useCurrentSmartview();

    return smartview;
}

export default observer(RenderCurrentSmartview);
